<template>
  <el-dialog title="Escuchar Audio" :visible.sync="show" :before-close="onCloseDialog">
    <el-row v-loading="loading" class="mt-2" type="flex" align="middle">
      <transition name="fade">
        <el-col :span="24">
          <audio :key="url" controls>
            <source :src="url" type="audio/mp3" />
          </audio>
        </el-col>
      </transition>
    </el-row>
  </el-dialog>
</template>

<script>
import { s3 } from "@/utils/s3";
import { GetObjectCommand } from "@aws-sdk/client-s3";
import { mapGetters } from "vuex";

export default {
  name: "AudioTripDialog",

  data() {
    return {
      url: "",
      loading: false,
    };
  },

  watch: {
    keyAudio(newVal) {
      if (newVal) {
        this.getUrl();
      }
    },
  },

  computed: {
    ...mapGetters("audioTripDialog", ["show", "keyAudio"]),
  },

  methods: {
    async getUrl() {
      this.loading = true;
      try {
        const data = await (
          await s3()
        ).send(
          new GetObjectCommand({
            Bucket: "callsrecording.pbx.2kbo.com",
            Key: this.keyAudio,
          })
        );
        const byteArray = await data.Body.transformToByteArray();
        const blob = new Blob([byteArray], { type: "audio/mp3" });
        this.url = URL.createObjectURL(blob);
      } catch (error) {
        alert("Failed to retrieve an object: " + error);
      } finally {
        this.loading = false;
      }
    },

    onCloseDialog() {
      this.url = "";
      this.$store.commit("audioTripDialog/setKeyAudio", "");
      this.$store.commit("audioTripDialog/setShow", false);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  max-width: 30%;
  &__header {
    padding-bottom: 0;
  }
  &__body {
    padding-top: 0;
  }

  audio {
    width: 100%;
  }
}
</style>
